import { autoinject } from "aurelia-framework";
import { RequestClientService } from "@rightship-tech/common-ui/services/basic/request-client.service";
import { BudgetRoutes } from "../../constants/budget/budgetRoutes";
import { BudgetClientModel } from "../../models/rightstore/rightstore.models";
import { ValidationResult } from "../../models/validations/validations.models";
import { ConfigService } from "@rightship-tech/common-ui/services/basic/config.service";

@autoinject
export class BudgetClientService {

    private rightStoreBaseApiUrl: string;

    constructor(private requestClient: RequestClientService, private configService: ConfigService) {
        this.rightStoreBaseApiUrl = this.configService.config.urls.rightStoreApiUrl;
    }

    public getAll(businessUnitId:number) {
        return this.requestClient.get<BudgetClientModel[]>(`${this.rightStoreBaseApiUrl}/api/${BudgetRoutes.GetAll}/${businessUnitId}`, {}) as Promise<BudgetClientModel[]>;
    }

    public get(budgetId:number) {
        return this.requestClient.get<BudgetClientModel>(`${this.rightStoreBaseApiUrl}/api/${BudgetRoutes.Get}/${budgetId}`, {}) as Promise<BudgetClientModel>;
    }

    public save(budget:BudgetClientModel) : Promise<SaveBudgetResponse> {
        return this.requestClient.post(`${this.rightStoreBaseApiUrl}/api/${BudgetRoutes.Save}`, {}, budget);
    }

    public delete(budgetId:number) {
        return this.requestClient.post(`${this.rightStoreBaseApiUrl}/api/${BudgetRoutes.Remove}/${budgetId}`, {}, {}) as Promise<void>;
    }

    public getAllByBusinessUnitId(businessUnitId: number) {
        return this.requestClient.get<BudgetClientModel[]>(`${this.rightStoreBaseApiUrl}/api/Budget/all/${businessUnitId}`, {}) as Promise<BudgetClientModel[]>;
    }

    public async getCreditBalance(businessUnitId: number): Promise<number> {
        const clientBudgets = await this.getAllByBusinessUnitId(businessUnitId);
        return clientBudgets.reduce((acc, val) => { return acc + val.remainingCredits }, 0)
    }
}

export interface SaveBudgetResponse {
    validationResult: ValidationResult;
}
